import { render, staticRenderFns } from "./imgtext.vue?vue&type=template&id=2df6882e&scoped=true&"
import script from "./imgtext.vue?vue&type=script&lang=js&"
export * from "./imgtext.vue?vue&type=script&lang=js&"
import style0 from "./imgtext.vue?vue&type=style&index=0&id=2df6882e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df6882e",
  null
  
)

export default component.exports